var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from "react";
import { getYoutubeId, getVimeoId, getMatterportId } from "@wrstudios/utils";
import { breakpoints } from "@wrstudios/theme";
import { IconPhoto, IconRotate, IconVideo } from "@wrstudios/icons";
import Slider from "../slider";
import HeroSlider from "../hero-slider";
import ListingMapStatic from "../listing-map-static";
import Media from "./Media";
import { Container, HeroSlide, Slide, LeftActions, LeftActionsTour, RightActions, Map, Tour, Photos } from "./styled/listing-slider";

var ListingSlider =
/** @class */
function (_super) {
  __extends(ListingSlider, _super);

  function ListingSlider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._isMounted = false;
    _this.state = {
      isContentOverflowing: false,
      isShowingMap: !_this.props.photos.length
    };

    _this.handleResize = function () {
      if (!_this._isMounted) return;

      _this.setState({
        isShowingMap: !_this.props.photos.length
      });
    };

    _this.handleShowingMap = function () {
      if (!_this._isMounted) return;

      _this.setState(function (_a) {
        var isShowingMap = _a.isShowingMap;
        return {
          isShowingMap: !isShowingMap
        };
      });
    };

    _this.handleContentOverflow = function (isContentOverflowing) {
      _this.setState({
        isContentOverflowing: isContentOverflowing
      });
    };

    return _this;
  }

  ListingSlider.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        mapboxApiToken = _a.mapboxApiToken,
        latitude = _a.latitude,
        longitude = _a.longitude,
        photos = _a.photos,
        zoomLevel = _a.zoomLevel,
        subjectPropertyPin = _a.subjectPropertyPin,
        virtualTour = _a.virtualTour,
        mapOptions = _a.mapOptions,
        onMapClick = _a.onMapClick,
        onPhotosClick = _a.onPhotosClick,
        onPhotoClick = _a.onPhotoClick,
        onTourClick = _a.onTourClick;
    var _b = this.state,
        isContentOverflowing = _b.isContentOverflowing,
        isShowingMap = _b.isShowingMap;
    return React.createElement(Container, null, !isShowingMap && React.createElement(Media, {
      query: "(min-width: " + breakpoints.sm + "px)"
    }, function (matches) {
      return matches ? React.createElement(HeroSlider, {
        mapboxApiToken: mapboxApiToken,
        onContentOverflow: _this.handleContentOverflow,
        latitude: latitude,
        longitude: longitude,
        zoomLevel: zoomLevel,
        subjectPropertyPin: subjectPropertyPin,
        mapOptions: mapOptions,
        onMapClick: onMapClick
      }, photos.map(function (photo, index) {
        return React.createElement(HeroSlide, {
          key: photo,
          src: photo,
          alt: "Listing Details #" + (index + 1),
          isLastSlide: index === photos.length - 1,
          onClick: function onClick() {
            return onPhotoClick(index);
          }
        });
      })) : React.createElement(Slider, null, photos.map(function (photo, index) {
        return React.createElement(Slide, {
          key: photo,
          id: "listing-slider-slide-" + index,
          style: {
            backgroundImage: "url('" + photo + "')"
          },
          "aria-label": "Image Slider - Slide " + (index + 1),
          onClick: function onClick() {
            return onPhotoClick(index);
          }
        });
      }));
    }), isShowingMap && React.createElement(ListingMapStatic, __assign({
      mapboxApiToken: mapboxApiToken,
      latitude: latitude,
      longitude: longitude,
      zoomLevel: zoomLevel,
      width: window.innerWidth,
      height: 250,
      pin: subjectPropertyPin
    }, mapOptions, {
      onClick: onMapClick
    })), !!this.props.photos.length && React.createElement(Map, {
      as: "div",
      tabIndex: 0,
      onClick: this.handleShowingMap
    }, isShowingMap && React.createElement("img", {
      src: this.props.photos[0],
      alt: "Listing Thumbnail"
    }), !isShowingMap && React.createElement(ListingMapStatic, {
      mapboxApiToken: mapboxApiToken,
      latitude: latitude,
      longitude: longitude,
      zoomLevel: zoomLevel,
      width: 48,
      height: 48,
      pin: subjectPropertyPin
    })), (isContentOverflowing || !!virtualTour) && React.createElement(React.Fragment, null, React.createElement(LeftActions, null, (photos.length > 5 || isContentOverflowing) && React.createElement(Photos, {
      onClick: onPhotosClick
    }, React.createElement(IconPhoto, null), photos.length), React.createElement(LeftActionsTour, null, React.createElement(ListingSliderVirtualTour, {
      virtualTour: virtualTour,
      onClick: onTourClick
    }))), React.createElement(RightActions, null, React.createElement(ListingSliderVirtualTour, {
      virtualTour: virtualTour,
      onClick: onTourClick
    }))));
  };

  ListingSlider.prototype.componentDidMount = function () {
    this._isMounted = true;
    window.addEventListener("resize", this.handleResize);
  };

  ListingSlider.prototype.componentWillUnmount = function () {
    this._isMounted = false;
    window.addEventListener("resize", this.handleResize);
  };

  ListingSlider.defaultProps = {
    zoomLevel: 15,
    mapOptions: {},
    onMapClick: function onMapClick() {},
    onPhotosClick: function onPhotosClick() {},
    onPhotoClick: function onPhotoClick() {},
    onTourClick: function onTourClick() {}
  };
  return ListingSlider;
}(Component);

function ListingSliderVirtualTour(_a) {
  var virtualTour = _a.virtualTour,
      onClick = _a.onClick;
  var youtubeId = getYoutubeId(virtualTour || "");
  var vimeoId = getVimeoId(virtualTour || "");
  var matterportId = getMatterportId(virtualTour || "");
  var hasSupportedTourType = Boolean(youtubeId || vimeoId || matterportId);
  if (!virtualTour) return null;
  return React.createElement(Tour, {
    as: hasSupportedTourType ? "button" : "a",
    href: hasSupportedTourType ? undefined : virtualTour,
    target: hasSupportedTourType ? undefined : "_blank",
    rel: hasSupportedTourType ? undefined : "noopener noreferrer",
    onClick: hasSupportedTourType ? onClick : undefined
  }, (youtubeId || vimeoId) && React.createElement(React.Fragment, null, React.createElement(IconVideo, null), "Video"), matterportId && React.createElement(React.Fragment, null, React.createElement(IconRotate, null), "360\xB0"), !youtubeId && !vimeoId && !matterportId && React.createElement(React.Fragment, null, React.createElement(IconPhoto, null), "Tour"));
}

export default ListingSlider;